import { observer, useAsObservableSource } from 'mobx-react-lite';
import React, { useState } from 'react';
import { CheckboxState } from './Switcher.state';
import {
    Input, PropsType, Slider, SwitcherWrapper, Wrapper
} from 'src/components/CmsCasinoManagement/EditFormComponents/Switcher/Switcher.style';

export const Switcher = observer((propsIn: PropsType) => {
    const props = useAsObservableSource(propsIn);
    const { state, disabled } = props;
    const [ switcherState ] = useState(() => new CheckboxState(state));

    return (
        <Wrapper disabled={disabled}>
            <SwitcherWrapper>
                <Input type={'checkbox'}
                    checked={switcherState.value}
                    readOnly
                    onChange={disabled === true ? undefined : switcherState.handleChange}/>
                <Slider/>
            </SwitcherWrapper>
        </Wrapper>
    );
});

